var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"fruits__view-item",attrs:{"src":_vm.src},on:{"click":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }